import { TailwindWrapper } from "@utils/TailwindWrapper";
import { useState, useRef } from "react";
import {
  Text,
  Icon,
  Button,
  PaginationDots,
  Slider,
} from "@ui-component-library";

const templates = {
  template1: [
    {
      quote:
        "Jag kan verkligen rekommendera Treebula till andra skogsägare. Hela upplevelsen har varit väldigt positiv och jag kommer att använda Treebula igen.",
      name: "Mikael Andersson",
      profession: "Skogsägare, Sala",
    },
    {
      quote:
        "Det var väldigt enkelt att skapa annonsen och man fick väldigt bra hjälp. Hela tiden har man en kontaktperson hos Treebula som kan hjälpa till och svara på frågor.",
      name: "Mårten Karlsson",
      profession: "Skogsägare, Årjäng",
    },
    {
      quote:
        "Det var inte bara de vanliga köparna, dem man känner till. Jag fick anbud av köpare som jag inte ens visste fanns.",
      name: "Daniel Johansson",
      profession: "Skogsägare, Uppland",
    },
  ],
  template2: [
    {
      quote:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      name: "John Appleseed",
      profession: "Forest owner, Falun",
    },
    {
      quote:
        "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      name: "Jane Doe",
      profession: "Forest owner, Stockholm",
    },
    {
      quote:
        "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
      name: "Bob Smith",
      profession: "Forest owner, Gothenburg",
    },
  ],
};

const QuoteSlider = (props) => {
  const selectedTemplate = props.template || "template1";
  const customerReviews = templates[selectedTemplate] || templates.template1;

  const [currentReviewIndex, setCurrentReviewIndex] = useState(0);
  const sliderRef = useRef(null);

  const handlePrev = () => {
    const newIndex = currentReviewIndex - 1;
    if (newIndex >= 0) {
      setCurrentReviewIndex(newIndex);
      sliderRef.current?.scrollTo(newIndex);
    }
  };

  const handleNext = () => {
    const newIndex = currentReviewIndex + 1;
    if (newIndex < customerReviews.length) {
      setCurrentReviewIndex(newIndex);
      sliderRef.current?.scrollTo(newIndex);
    }
  };

  const handleDotSelect = (index) => {
    const newIndex = index;
    if (newIndex >= 0 && newIndex < customerReviews.length) {
      setCurrentReviewIndex(newIndex);
      sliderRef.current?.scrollTo(newIndex);
    }
  };

  return (
    <TailwindWrapper>
      <div className="w-full bg-[#f5f3f1] min-h-[364px]">
        <div className="container flex flex-col">
          <section className="flex flex-col gap-12 py-4 lg:py-16">
            <div className="relative">
              <Slider ref={sliderRef} desktopVisible={1} mobileVisible={1}>
                {customerReviews.map((item, index) => (
                  <div
                    key={index}
                    className="flex items-center gap-4 flex-col min-h-[375px] max-w-[864px] lg:px-24 lg:m-auto"
                  >
                    <Text
                      variant="sectionHeaderMedium"
                      className="text-charcoal-500 text-[95px] mb-[-64px] leading-none self-start"
                    >
                      ”
                    </Text>
                    <Text
                      variant="sectionHeaderMedium"
                      className="mb-12 text-charcoal-500"
                    >
                      {item.quote}
                    </Text>
                    <div className="flex items-center flex-row gap-1">
                      <Text
                        variant="labelMediumMedium"
                        className="text-charcoal-500"
                      >
                        {item.name}
                      </Text>
                      <Text
                        variant="labelMediumRegularDense"
                        className="text-pebble-500"
                      >
                        - {item.profession}
                      </Text>
                    </div>
                  </div>
                ))}
              </Slider>

              <div className="flex justify-between items-center mt-8">
                <PaginationDots
                  total={customerReviews.length}
                  activeIndex={currentReviewIndex}
                  onDotSelect={handleDotSelect}
                  className="cursor-pointer"
                />

                <div className="flex gap-3">
                  <Button
                    tw
                    variant="primary"
                    onClick={handlePrev}
                    disabled={currentReviewIndex === 0}
                    className="bg-[#0F0F0F] disabled:bg-[#828180]"
                  >
                    <Icon
                      tw
                      name="ArrowShortSimple"
                      size="medium"
                      className="fill-white"
                    />
                  </Button>

                  <Button
                    tw
                    variant="primary"
                    onClick={handleNext}
                    disabled={
                      currentReviewIndex >=
                      (sliderRef.current?.getMaxIndex() ||
                        customerReviews.length - 1)
                    }
                    className="bg-[#0F0F0F] disabled:bg-[#828180]"
                  >
                    <Icon
                      tw
                      name="ArrowShortSimple"
                      size="medium"
                      className="rotate-180 fill-white"
                    />
                  </Button>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </TailwindWrapper>
  );
};

QuoteSlider.defaultProps = {
  template: "template1",
};

QuoteSlider.fields = {
  template: {
    type: "select",
    label: "Review Template",
    options: [
      { label: "Inloggat läge", value: "template1" },
      { label: "Template 2", value: "template2" },
    ],
  },
};

export default QuoteSlider;
